import { useEffect } from 'react'
import AOS from 'aos'
import Button from '@ui/Button'
import MetaInfo from '@/components/common/MetaInfo'
// import BusinessGrowSection from '@sections/BusinessGrowSection'
// import CustomerReachSection from '@sections/CustomerReachSection'
// import BusinessGrowthSection from '@sections/BusinessGrowthSection'
import TransformBanner from '@sections/TransformBanner'
import Breadcrumb from '@common/Breadcrumb'
import { ROUTES } from '@/constants'
import { Link } from 'react-router-dom'
export default function Sample() {
 // useEffect(() => { AOS.refresh(); window.scrollTo(0, 0) }, [])
  const IMG_BASE = 'https://www.cruxbytes.com/images'


const FORMULA_LEGEND = [
  { key: 'C', label: 'Conversion' },
  { key: 'M', label: 'Motivation' },
  { key: 'V', label: 'Value Proposition' },
  { key: 'I', label: 'Incentive' },
  { key: 'F', label: 'Friction' },
  { key: 'A', label: 'Anxiety' },
]

  return (
      <>
        <MetaInfo
          title="Software Consulting | CruxBytes Consultancy Services"
          description="Customized landing pages are required from a project to project basis. It is important that the user comes to a page and finds a value proposition that is similar in nature to the advertising he has reacted to. Also, customized landing pages make it easier to track campaign performance and determine ROI."
        
        />
        <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- Application Consulting -</div> */}
             <Breadcrumb />
             <h1>Software Consulting</h1>
             <p className="page-subtitle">
             Transforming ideas into scalable web, mobile, and cloud solutions.
             </p>
             
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right">
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
        <section className="bgs-section--tint2 section-py" aria-labelledby="bgs-reach-heading">
      <div className="container">
        <div className="text-align-center" data-aos="fade-up">
          <h2 id="bgs-reach-heading">
           1. Enabling customers to find and consider your business
          </h2>
        </div>

      

        {/* Row 2 — Email marketing (text-only, no reference image) */}
        <div className="bgs-row bgs-row--text-only" data-aos="fade-up">
          <div className="bgs-row-content">
            
           
            <p className="text-align-center text-white" >
              Email marketing is used at three stages of consumer lifecycle management — one is
              to acquire new customers, second is to nurture leads and third is to keep customers
              periodically updated with relevant information. Email is an important component of
              CRM (nurture leads) which involves email design (content and aesthetics) and email
              development (coding emails to a format that can be sent to multiple consumers to
              collect information).
            </p>
            <p className="text-align-center text-white" >
              CruxBytes will develop email templates and compile the necessary content required
              to reach out to consumers at different stages of communication. We will also code
              all emails and send those via publishers to the right audience.
            </p>
          </div>
        </div>

      </div>
    </section>
          <section className="bgs-section section-py" aria-labelledby="bgs-grow-heading">
              <div className="bgs-blob bgs-blob--brand bgs-blob--top-right" aria-hidden="true" />
              <div className="bgs-blob bgs-blob--accent bgs-blob--bottom-left" aria-hidden="true" />
              <div className="container">
        
                <div className="text-align-center" data-aos="fade-up">
                  <h2 id="text-align-center" >2.all businesses grow.</h2>
                </div>
        
               
                {/* Row 2 — Landing pages + Conversion formula */}
                <div className="bgs-row bgs-row--reverse">
                  <div className="bgs-row-media" data-aos="fade-left">
                    <div className="bgs-row-media-inner">
                      <img
                        src={`${IMG_BASE}/snehamumbai.jpg`}
                        alt="SNEHA Mumbai custom landing page"
                        loading="lazy"
                        width="640"
                        height="480"
                      />
                    </div>
                    <span className="bgs-row-chip"><i className="fa-solid fa-bullseye" aria-hidden="true" />Landing Pages</span>
                  </div>
                  <div className="bgs-row-content" data-aos="fade-right">
                  <p >
                      Customized landing pages are required from a project to project basis. It is
                      important that the user comes to a page and finds a value proposition that is
                      similar in nature to the advertising he has reacted to. Also, customized landing
                      pages make it easier to track campaign performance and determine ROI.
                    </p>
                    <p >
                      We have a formula based approach to designing and developing landing pages. Using
                      this theory, we make sure that maximum users convert and provide us their valuable
                      details. Our expertise in web design and development.
                    </p>
        
                    <div className="bgs-formula-card">
                      <p>
                       <Button variant="secondary" icon="fa-arrow-right" iconPos="right">
                      C = 4M + 3V + 2(I − F) − 2A
                    </Button></p>
                      <ul className="bgs-formula-legend">
                        {FORMULA_LEGEND.map(item => (
                          <li key={item.key}><strong>{item.key}</strong> {item.label}</li>
                        ))}
                      </ul>
                    </div>
        
                    <Link to={ROUTES.SALES_ENQUIRY} className="bgs-link">
                      Learn more about our &lsquo;Website with a purpose&rsquo; methodology
                      <i className="fa-solid fa-arrow-right" aria-hidden="true" />
                    </Link>
                  </div>
                </div>
                             
              </div>
            </section>
          
       
        
         <section className="bgs-section bgs-section--tint section-py" aria-labelledby="bgs-reach-heading">
      <div className="bgs-blob bgs-blob--accent bgs-blob--top-right" aria-hidden="true" />
      <div className="container">

        <div className="text-align-center" data-aos="fade-up">
          <h2 id="bgs-reach-heading">
            3.Enabling customers to find and consider your business
          </h2>
        </div>

       

        {/* Row 2 — Email marketing (text-only, no reference image) */}
        <div className="bgs-row bgs-row--text-only" data-aos="fade-up">
          <div className="bgs-row-content">
          
            <p style={{color: 'var(--bg-primary)'}}>
              Email marketing is used at three stages of consumer lifecycle management — one is
              to acquire new customers, second is to nurture leads and third is to keep customers
              periodically updated with relevant information. Email is an important component of
              CRM (nurture leads) which involves email design (content and aesthetics) and email
              development (coding emails to a format that can be sent to multiple consumers to
              collect information).
            </p>
            <p style={{color: 'var(--bg-primary)'}}>
              CruxBytes will develop email templates and compile the necessary content required
              to reach out to consumers at different stages of communication. We will also code
              all emails and send those via publishers to the right audience.
            </p>
          </div>
        </div>

      </div>
    </section>
    <section className="container">
            <div className="split-showcase" data-aos="fade-up">
    
              {/* Left: statement + testimonial */}
              <div className="split-showcase-panel split-showcase-panel--text">
                <h2 className="split-showcase-heading">
                  Our People
                </h2>
                <span className="split-showcase-divider" aria-hidden="true" />
                <blockquote className="split-showcase-quote">
                  <p>
                    Our team members are the spine of our company’s growth. We offer a very positive work environment and growth opportunities. Our <u>culture and values</u> remain an integral part of our company’s growth story. Our alumni still cherish the time they spent at CruxBytes.
                  </p>
                  <footer className="split-showcase-quote-footer">
                    <span className="split-showcase-avatar" aria-hidden="true">DM</span>
                    <div className="split-showcase-quote-meta">
                      DUMMY Daniel Mercer
                      <span>Mercer &amp; Lane Studios</span>
                    </div>
                  </footer>
                </blockquote>
              </div>
    
              {/* Right: photo + overlay content */}
              <div className="split-showcase-panel split-showcase-panel--media">
                <img
                  className="split-showcase-photo"
                  src="/assets/images/leadship-quote.jpg"
                  alt="Developer workspace with multiple monitors displaying code"
                  loading="lazy"
                />
                <span className="split-showcase-indicator" aria-hidden="true" />
                <div className="split-showcase-content">
                  <h3>DUMMY Discover The Beauty Of Intentional Interiors</h3>
                  <p>
                    DUMMYFrom curated materials to meaningful details, we craft
                    environments where functionality and aesthetics work in
                    harmony.
                  </p>
                  <div className="split-showcase-actions">
                    <Button
                      href={ROUTES.SALES_ENQUIRY}
                     variant="primary"             
                    >
                      Start Your Project
                    </Button>
                    <Button
                      href={ROUTES.OUR_WORK}
                      variant="outline"
                    >
                      See Our Work
                    </Button>
                  </div>
                </div>
              </div>
    
            </div>
          </section>
         {/* ── New Section: Why Consulting + Our Approach ── */}
<section className="sc-section section-py" aria-labelledby="sc-section-heading">
  <div className="container">

    {/* Row 1 — Left: text, Right: stats */}
    <div className="sc-row" data-aos="fade-up">
      <div className="sc-col-text">
        <span className="process-eyebrow">Why It Matters</span>
        <h2 id="sc-section-heading" >
          4. The right technology strategy drives growth
        </h2>
        <p >
          In today's fast-moving digital landscape, businesses that align their technology decisions with their core objectives consistently outperform those that don't. Software consulting bridges the gap between business vision and technical execution — helping you avoid costly mistakes, reduce time-to-market, and build systems that scale with your ambitions.
        </p>
        <p >
          Whether you are starting from scratch, modernizing legacy systems, or scaling an existing platform, our consultants bring the clarity and direction your team needs to move forward with confidence.
        </p>
      </div>

      <div className="sc-col-stats">
        {[
          { icon: 'fa-rocket',        value: '200+', label: 'Projects Delivered' },
          { icon: 'fa-calendar-days', value: '10+',  label: 'Years of Experience' },
          { icon: 'fa-users',         value: '95%',  label: 'Client Satisfaction' },
          { icon: 'fa-code',          value: '50+',  label: 'Technologies Covered' },
        ].map((stat, i) => (
          <div key={stat.label} className="sc-stat" data-aos="fade-up" data-aos-delay={i * 80}>
            <span className="sc-stat-icon" aria-hidden="true">
              <i className={`fa-solid ${stat.icon}`} />
            </span>
            <div className="sc-stat-body">
              <span className="sc-stat-value">{stat.value}</span>
              <span className="sc-stat-label">{stat.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
</div></section>
  
{/* ── Centered heading + two-column text section ── */}
<section className="section-py bg-linear-gradient-light" aria-labelledby="sc-split-heading">
  <div className="container">

    <div className="text-align-center" data-aos="fade-up">
      <h2 id="sc-split-heading" >
        5.Why businesses trust us with their <span className="bgs-heading-accent">technology decisions</span>
      </h2>
      <p className="text-align-center">
        From early discovery to long-term advisory, we bring the expertise, structure, and honesty that complex software challenges demand.
      </p>
    </div>

    <div className="sc-split-row">
      <div className="sc-split-col" data-aos="fade-right">
        <p className="sc-text-para">
          Software consulting is fundamentally about trust. Businesses come to us at critical inflection points — when they are about to make a significant technology investment, when a past decision has created technical debt that is slowing them down, or when they simply need an experienced outside perspective to validate their internal thinking.
        </p>
        <p className="sc-text-para">
          In those moments, what matters most is not the breadth of our technology certifications but the quality of our judgment. We ask the difficult questions early, challenge assumptions respectfully, and always prioritize your business outcome over the elegance of any particular technical solution.
        </p>
      </div>

      <div className="sc-split-col" data-aos="fade-left">
        <p className="sc-text-para">
          Our consultants have worked across industries ranging from healthcare and government to fintech and e-commerce. That diversity of experience gives us a rare ability to recognize patterns — to see where a problem a retail client faces today is structurally similar to one we solved for a logistics company two years ago — and to apply those lessons intelligently.
        </p>
        <p className="sc-text-para">
          We do not arrive with a predetermined answer. We arrive with a framework for finding the right one. That means our engagements are collaborative by design — your domain knowledge combined with our technical depth produces outcomes that neither of us could reach independently.
        </p>
        <p className="sc-text-para">
          That collaborative spirit, combined with clear communication and measurable deliverables, is why our clients return to us engagement after engagement.
        </p>
      </div>
    </div>

  </div>
</section>
{/* ── Text-only two-column section ── */}
<section className="sc-text-section section-py" aria-labelledby="sc-text-heading">
  <div className="container">
    <div className="sc-text-row">

      <div className="sc-text-col-left" data-aos="fade-right">
        <h2 id="sc-text-heading" >
          6.Building software that grows <span className="bgs-heading-accent">with your business</span>
        </h2>
        <p className="sc-text-para">
          Technology is not a one-time investment — it is an ongoing commitment to staying relevant, competitive, and efficient. The most successful businesses treat their software as a living asset, one that evolves alongside their customers, markets, and internal processes. Our consulting practice is built on this principle.
        </p>
        <p className="sc-text-para">
          We help you move beyond short-term fixes and toward a sustainable technology foundation. Every decision we guide — from database architecture to third-party integrations — is made with your long-term growth in mind, not just the immediate requirement in front of us.
        </p>
      </div>

      <div className="sc-text-col-right" data-aos="fade-left">
        <p className="sc-text-para">
          Scalability is often misunderstood as simply handling more users. In reality, it means your systems can adapt to new business models, geographies, regulatory requirements, and technology shifts without requiring a complete rebuild. That kind of resilience is designed in from the beginning — not bolted on later.
        </p>
        <p className="sc-text-para">
          Our consultants bring experience across diverse industries and technology stacks, which means we have seen what works and what fails at scale. We translate that experience into practical recommendations your team can implement with confidence — whether you are a startup building your first product or an enterprise modernizing a decade-old platform.
        </p>
        <p className="sc-text-para">
          The goal is not to make you dependent on consultants indefinitely. It is to equip your team with the right architecture, tooling, and processes so that your organization can innovate independently and sustainably for years to come.
        </p>
      </div>

    </div>
  </div>
</section>


{/* ── Variation 2: Heading Left, Content Right ── */}
<section className="sc-v2-section section-py" aria-labelledby="sc-v2-heading">
  <div className="container">
    <div className="sc-v2-row" data-aos="fade-up">
      <div className="sc-v2-col-left">
        <h2 id="sc-v2-heading" >
         7. Our consulting <span className="bgs-heading-accent">process</span>
        </h2>
        <p >
          Structured thinking. Honest advice. Measurable outcomes.
        </p>
      </div>
      <div className="sc-v2-col-right">
        <p className="sc-text-para">
          Every engagement begins with listening. Before we recommend anything, we invest time understanding your business model, your team's capabilities, your existing technology landscape, and the specific outcomes you are trying to achieve. This foundation ensures that our recommendations are grounded in your reality — not in a generic best-practice playbook.
        </p>
        <p className="sc-text-para">
          From there we move into structured analysis. We map dependencies, identify risks, evaluate build-versus-buy tradeoffs, and assess the maturity of your current systems. This phase often surfaces issues that were not visible before — technical debt that is quietly slowing the team, integration bottlenecks that will become critical at scale, or organizational gaps that no amount of tooling can fix.
        </p>
        <p className="sc-text-para">
          Finally we translate all of that into a clear, prioritized action plan. Not a hundred-page report that sits on a shelf — but a practical roadmap your team can execute against, with defined milestones, ownership, and success criteria. We remain available throughout implementation to answer questions, review decisions, and adjust course as needed.
        </p>
      </div>
    </div>
  </div>
</section>

{/* ── Variation 3: 3 Column Text ── */}
<section className="sc-v3-section section-py" aria-labelledby="sc-v3-heading">
  <div className="container">
    <div className="sc-v3-header" data-aos="fade-up">
      <h2 id="sc-v3-heading" className="sc-v3-heading">
        8.The three pillars of <span className="bgs-heading-accent">sustainable software</span>
      </h2>
      <p className="sc-subtitle">
        Lasting technology success is built on the intersection of people, process, and technology — never on any one of them alone.
      </p>
    </div>
    <div className="sc-v3-row">
      <div className="sc-v3-col" data-aos="fade-up" data-aos-delay="0">
        <h3 className="sc-v3-col-heading">People</h3>
        <p className="sc-text-para">
          The most sophisticated technology will underperform in the hands of a team that does not understand it or trust it. We help you assess your team's current capabilities, identify skill gaps, and design structures — whether internal hiring, training, or strategic outsourcing — that set your people up for long-term success.
        </p>
        <p className="sc-text-para">
          Culture matters as much as capability. We help you build an engineering culture that values quality, transparency, and continuous improvement — because that culture is ultimately what determines how well your technology investments pay off over time.
        </p>
      </div>
      <div className="sc-v3-col" data-aos="fade-up" data-aos-delay="100">
        <h3 className="sc-v3-col-heading">Process</h3>
        <p className="sc-text-para">
          Good process is invisible when it works and painfully visible when it does not. We help you design development workflows, code review practices, deployment pipelines, and incident response procedures that reduce friction without introducing unnecessary bureaucracy.
        </p>
        <p className="sc-text-para">
          The right process scales with your team. What works for a five-person startup will break at fifty engineers. We help you anticipate those inflection points and evolve your processes proactively — before they become bottlenecks that slow delivery or compromise quality.
        </p>
      </div>
      <div className="sc-v3-col" data-aos="fade-up" data-aos-delay="200">
        <h3 className="sc-v3-col-heading">Technology</h3>
        <p className="sc-text-para">
          Technology choices have long-lasting consequences. The framework you choose today, the database architecture you design, the APIs you expose — these decisions shape what is possible for your product years into the future. We help you make those choices with full awareness of their implications.
        </p>
        <p className="sc-text-para">
          We evaluate technology not just on its current capabilities but on its trajectory, community health, vendor stability, and fit with your team's existing skills. The goal is always to choose technology that your team can own confidently — not technology that requires constant specialist intervention to keep running.
        </p>
      </div>
    </div>
  </div>
</section>

{/* ── Variation 5: Pull Quote + Supporting Text ── */}
<section className="sc-v5-section section-py" aria-labelledby="sc-v5-heading">
  <div className="container">
    <div className="sc-v5-row" data-aos="fade-up">
      <div className="sc-v5-col-quote">
        <span className="sc-v5-quote-mark" aria-hidden="true">"</span>
        <p className="sc-v5-quote-text">
          The best technology decision is not always the most advanced one — it is the one your team can own, maintain, and evolve with confidence.
        </p>
        <span className="sc-v5-quote-attr">— CruxBytes Consulting Philosophy</span>
      </div>
      <div className="sc-v5-col-content">
        <h2 id="sc-v5-heading" className="sc-v5-heading">
          9.Advice you can <span className="bgs-heading-accent">act on</span>
        </h2>
        <p className="sc-text-para">
          There is no shortage of opinions in the technology industry. Every conference, every blog post, every vendor pitch arrives with confident recommendations about what you should build, which platform you should use, and which architectural pattern will solve all your problems. The challenge is not finding advice — it is finding advice that is honest, contextual, and genuinely in your interest.
        </p>
        <p className="sc-text-para">
          That is the standard we hold ourselves to at CruxBytes. We have no preferred vendors to promote, no proprietary frameworks to sell, and no interest in making you dependent on our involvement longer than necessary. Our only goal is to help you make better decisions — and then to help you execute them well.
        </p>
        <p className="sc-text-para">
          When we tell you something is the right path forward, it is because we genuinely believe it is — based on evidence, experience, and a clear understanding of your specific situation. That commitment to honest, actionable advice is what our clients value most, and it is the principle that guides every engagement we take on.
        </p>
      </div>
    </div>
  </div>
</section>
{/* ── Discover Section (dark card with image) ── */}
<section className="sc-discover-section section-py" aria-labelledby="sc-discover-heading">
  <div className="container">
    <div className="sc-discover-card">

      {/* Decorative arc lines */}
      <svg className="sc-discover-arcs" viewBox="0 0 300 300" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <circle cx="0" cy="150" r="100" stroke="rgba(255,255,255,0.06)" strokeWidth="1.5" fill="none"/>
        <circle cx="0" cy="150" r="150" stroke="rgba(255,255,255,0.05)" strokeWidth="1.5" fill="none"/>
        <circle cx="0" cy="150" r="200" stroke="rgba(255,255,255,0.04)" strokeWidth="1.5" fill="none"/>
        <circle cx="0" cy="150" r="250" stroke="rgba(255,255,255,0.03)" strokeWidth="1.5" fill="none"/>
      </svg>

      {/* Left — text content */}
      <div className="sc-discover-content" data-aos="fade-right">
        <h2 id="sc-discover-heading" className="sc-discover-heading">
         10. Discover CruxBytes In A Flash
        </h2>
        <p className="sc-discover-para">
          See how innovation drives every aspect of what we do — from building scalable software architectures to delivering consulting strategies that create real, measurable business impact.
        </p>
        <p className="sc-discover-para">
          Our approach combines deep technical expertise with a genuine understanding of business goals, ensuring every solution we deliver is built to last and designed to grow.
        </p>
      </div>

      {/* Right — static image */}
      <div className="sc-discover-media" data-aos="fade-left">
        <div className="sc-discover-img-wrap">
          <img
            src="https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&q=80"
            alt="Technology innovation at CruxBytes"
            className="sc-discover-img"
            loading="lazy"
            width="800"
            height="450"
          />
        </div>
      </div>

    </div>
  </div>
</section>
{/* ── Testimonial Section ── */}
<section className="sc-tm-section2 section-py" aria-labelledby="sc-tm-heading">
  <div className="container">
    <div className="sc-tm-row">

      {/* Left — testimonial card */}
      <div className="sc-tm-card-wrap" data-aos="fade-right">
        <div className="sc-tm-card">
          <div className="sc-tm-stars" aria-label="5 out of 5 stars">
            {[...Array(5)].map((_, i) => (
              <i key={i} className="fa-solid fa-star" aria-hidden="true" />
            ))}
          </div>
          <p className="sc-tm-title">Exceptional consulting that transformed our platform</p>
          <p className="sc-tm-quote">
            CruxBytes brought clarity to a technology decision we had been struggling with for months. Their consultants asked the right questions, challenged our assumptions, and delivered a roadmap that our team could actually execute. Six months later, our platform is faster, more stable, and ready to scale. We could not have done it without their guidance.
          </p>
          <div className="sc-tm-author">
            <div className="sc-tm-avatar" aria-hidden="true">RK</div>
            <div className="sc-tm-author-info">
              <span className="sc-tm-name">Rahul Khanna</span>
              <span className="sc-tm-role">CTO, FinVerse Technologies</span>
            </div>
          </div>
        </div>
      </div>

      {/* Right — heading + subtitle */}
      <div className="sc-tm-content" data-aos="fade-left">
        <span className="process-eyebrow">Client Reviews</span>
        <h2 id="sc-tm-heading" className="sc-tm-heading">
          11.What our clients say about our <span className="bgs-heading-accent">consulting services</span>
        </h2>
        <p >
          Over the years, CruxBytes has partnered with startups, growing businesses, and enterprises to navigate complex technology challenges. Here is what they have to say about the experience.
        </p>
      </div>

    </div>
  </div>
</section>
{/* ── Code We Live By Section ── */}
<section className="sc-code-section section-py" aria-labelledby="sc-code-heading">

  {/* Decorative curves — top left */}
  <svg className="sc-code-curve sc-code-curve--left" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="0" cy="0" r="100" stroke="rgba(255,255,255,0.5)" strokeWidth="1" fill="none"/>
    <circle cx="0" cy="0" r="180" stroke="rgba(255,255,255,0.5)" strokeWidth="1" fill="none"/>
    <circle cx="0" cy="0" r="260" stroke="rgba(255,255,255,0.5)" strokeWidth="1" fill="none"/>
  </svg>

  {/* Decorative curves — top right */}
  <svg className="sc-code-curve sc-code-curve--right" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="400" cy="0" r="100" stroke="rgba(255,255,255,0.5)" strokeWidth="1" fill="none"/>
    <circle cx="400" cy="0" r="180" stroke="rgba(255,255,255,0.5)" strokeWidth="1" fill="none"/>
    <circle cx="400" cy="0" r="260" stroke="rgba(255,255,255,0.5)" strokeWidth="1" fill="none"/>
  </svg>

  <div className="container">

    {/* Heading */}
    <div className="sc-code-header" data-aos="fade-up">
      <h2 id="sc-code-heading" className="sc-code-heading">
        12.The Code We Live By
      </h2>
    </div>

    {/* 4 columns */}
    <div className="sc-code-grid">
      {[
        {
          icon: 'fa-chart-bar',
          title: 'Mutual Growth',
          desc: 'We believe that true success is achieved not by acting as a mere vendor, but as a technology partner who comprehensively understands your vision. By aligning our goals with yours, we foster a collaborative environment ensuring that our growth is intrinsically linked to your success.',
        },
        {
          icon: 'fa-gear',
          title: 'Process Orientation',
          desc: 'We are committed to a process-oriented software delivery model, emphasizing the importance of consistent processes and documented procedures. We actively encourage all departments to strictly adhere to the formulated SOPs, fostering a culture of discipline and efficiency.',
        },
        {
          icon: 'fa-handshake',
          title: 'Integrity',
          desc: 'We pride ourselves on being straightforward and honest in all our business relationships. Our commitment to integrity means we are always truthful about the services we provide, the depth of our knowledge, and the experience we have gained over the years.',
        },
        {
          icon: 'fa-briefcase',
          title: 'Fair Business Practices',
          desc: 'We promote our services based solely on their own merits, refraining from making any unfair or misleading statements about the offerings of our competitors. We uphold a strong sense of respect for our competitors and are firmly committed to fair and ethical business practices.',
        },
      ].map((item, i) => (
        <div
          key={item.title}
          className="sc-code-col"
          data-aos="fade-up"
          data-aos-delay={i * 80}
        >
          {i > 0 && <div className="sc-code-divider" aria-hidden="true" />}
          <i className={`fa-solid ${item.icon} sc-code-icon`} aria-hidden="true" />
          <h3 className="sc-code-title">{item.title}</h3>
          <p className="sc-code-desc">{item.desc}</p>
        </div>
      ))}
    </div>

  </div>
</section>

         <TransformBanner />
         </main>
      </>
  )
}